import { render, staticRenderFns } from "./SoloResellerSelect.vue?vue&type=template&id=affb58ea&"
import script from "./SoloResellerSelect.vue?vue&type=script&lang=js&"
export * from "./SoloResellerSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports